import { Router, ActivatedRoute, Params } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import {
  CustomProffixService, UserSessionService, HelpersService, StundenAntrag,
  AbwesenheitsAntrag, AbwesenheitsAntragStunden
} from '../../services';

import {
  Login,
  Mitarbeiter,
  MitarbeiterService,
  StundeninfoService,
  Stundeninfo,
  StundenService,
  Stunden
} from '@proffix/restapi-angular-library';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  proffixLogin: Login = null;

  isLoaded = false;
  isManager = false;
  isTeamleiter = false;

  
  currentMitarbeiter: Mitarbeiter;

  listOfMitarbeiter: Mitarbeiter[] = [];
  stundenInfo: Stundeninfo;
  stundenList: Stunden[];
  stundenAntraegeList: StundenAntrag[];
  listOfAbwesenheitsAntraege: AbwesenheitsAntrag[];

  calculatedKompensationsStunden: number;

  constructor(
    private _customProffixService: CustomProffixService,
    private _userSessionService: UserSessionService,
    private _helpersService: HelpersService,
    private _stundenService: StundenService,
  ) { }

  ngOnInit() {
    this._userSessionService.getProffixLogin().subscribe(data => {
      this.proffixLogin = data;
      this.isManager = this._userSessionService.isManager();
      this.isTeamleiter = this._userSessionService.isTeamleiter();

      if (data && data.Mitarbeiter) {
        this.currentMitarbeiter = data.Mitarbeiter;

        this.loadDashboardData();

        // load the list of all Mitarbeiter that the current user is allowed to see
        this._customProffixService
          .getListOfAssignedMitarbeiter(this.proffixLogin.Mitarbeiter.MitarbeiterNr, this.isManager)
          .subscribe(mitarbeiterList => {
            this.listOfMitarbeiter = this.SortMitarbeiterByName(mitarbeiterList);

          });
      }
    });
  }

  private loadDashboardData() {
    const now = new Date();
    this.isLoaded = false;

    this._stundenService.getAll(
      {
        sort: '-Datum',
        limit: 5,
        offset: 0,
        filter: 'Mitarbeiter==' + this.currentMitarbeiter.MitarbeiterNr,
      }).subscribe((stundenList) => {
        this.stundenList = stundenList;

        this._customProffixService.getAllStundeninfo({
          mitarbeiter: this.currentMitarbeiter.MitarbeiterNr,
          datum: now.getDate() + '.' + (now.getMonth() + 1) + '.' + now.getFullYear(),
        })
          .subscribe((stundenInfo) => {
            this.stundenInfo = stundenInfo;

            this._customProffixService.getStundenAntrag({
              sort: '-GeaendertAm',
              limit: 5,
              offset: 0,
              filter: 'MitNrPRO==' + this.currentMitarbeiter.MitarbeiterNr,
            }).subscribe((stundenAntraegeList) => {
              this.stundenAntraegeList = stundenAntraegeList;

              this._customProffixService.getAbwesenheitsAntraege(
                {
                  sort: '-GeaendertAm',
                  limit: 5,
                  offset: 0,
                  filter: 'MitNrPRO==' + this.currentMitarbeiter.MitarbeiterNr,
                }).subscribe((result) => {
                  this.listOfAbwesenheitsAntraege = result;
                  this.isLoaded = true;

                  // calculate the "Kompensation"
                  this._stundenService.getAll(
                    {
                      sort: '-Datum',
                      limit: 9999,
                      offset: 0,
                      depth: 0,
                      // @ts-ignore: Unknown but functional GET parameter
                      gesperrt: 'any',
                      filter: 'Mitarbeiter==' + this.currentMitarbeiter.MitarbeiterNr + ',(Stundenart=="ZEITGU"|Stundenart=="ZEITGUBEZ")',
                    }).subscribe((kompensationenList) => {
                      this.calculatedKompensationsStunden = 0.0;

                      for (const std of kompensationenList) {
                        // const hours = this._helpersService.calculateTimeSpan(std.StartZeit, std.EndZeit);
                        // this.calculatedKompensationsStunden += hours - std.Pause;

                        if (std.Stundenart.StundenartNr === 'ZEITGU') {
                          this.calculatedKompensationsStunden += std.Stunden;
                        } else if (std.Stundenart.StundenartNr === 'ZEITGUBEZ') {
                          this.calculatedKompensationsStunden -= std.Stunden;
                        }
                      }

                      // round to a precision of two decimal digits
                      this.calculatedKompensationsStunden = Math.round(this.calculatedKompensationsStunden * 100) / 100;
                    });
                });
            });
          });
      });
  }

  public changeMitarbeiter() {
    this.loadDashboardData();
  }

  public filterVisibleMitarbeiter(ma: Mitarbeiter): boolean {
    return ma && ma.Zusatzfelder
      && ma.Zusatzfelder.Z_Zeitmanagement_Rolle
      && ma.Zusatzfelder.Z_Zeitmanagement_Rolle !== '';
  }

  private SortMitarbeiterByName(listOfMitarbeiter: Mitarbeiter[]): Mitarbeiter[] {
    listOfMitarbeiter.sort((x, y) => {
      if (x.Adresse.Name < y.Adresse.Name) {
        return -1;
      } else if (x.Adresse.Name > y.Adresse.Name) {
        return 1;
      } else {
        return 0;
      }
    });

    return listOfMitarbeiter;
  }

  public convertHoursToDays(hours: number, hoursPerDay: number): number {
    return this.roundToTwoDigits(hours / hoursPerDay);
  }

  public roundToTwoDigits(value: number): number {
    return Math.round(value * 100) / 100;
  }
}



// WEBPACK FOOTER //
// C:/.NET Projects/Angular Apps/TimeManagement/src/app/dialogs/dashboard/dashboard.component.ts